import React from 'react';
import { MESSAGE_DIRECTION } from '@whatsper/texterchat-common';
import DeletedContent from '../../DeletedContent';
const DeletedMessage = ({ deleted, direction }) => {
    if (!deleted) {
        return null;
    }
    return (React.createElement(DeletedContent, { previousType: deleted.previousType, timestamp: deleted.timestamp, outgoing: direction === MESSAGE_DIRECTION.OUT }));
};
export default DeletedMessage;
